export default {
  title: '短信日志',

  // 表单相关
  form: {
    timeRange: '时间范围',
    sendTime: '发送时间',
    startDate: '开始日期',
    endDate: '结束日期',
    task: '任务',
    taskName: '任务名称',
    taskPlaceholder: '请选择任务',
    taskNamePlaceholder: '请选择任务名称',
    taskType: '任务类型',
    taskTypePlaceholder: '请选择任务类型',
    username: '用户名',
    userName: '用户名',
    user: '用户',
    usernamePlaceholder: '请输入用户名',
    userNamePlaceholder: '请输入用户名',
    userPlaceholder: '请输入用户名',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    channel: '通道',
    channelPlaceholder: '请选择通道',
    status: '状态',
    statusPlaceholder: '请选择状态',
    receipt: '回执码',
    receiptPlaceholder: '请输入回执码',
    updateTime: '更新时间',
    updateTimePlaceholder: '请选择更新时间'
  },

  // 表格相关
  table: {
    time: '时间',
    task: '任务',
    user: '用户',
    phone: '手机号',
    channel: '通道',
    status: '状态',
    receipt: '回执码'
  },

  // 状态相关
  status: {
    pending: '待发送',
    success: '成功',
    failed: '失败',
    unknown: '未知'
  },

  // 导出相关
  export: {
    button: '导出',
    loading: '导出任务已创建，请在下载列表中查看进度',
    statusNotFailed: '仅支持导出状态为「失败」的记录。请将筛选条件中的「状态」设为「失败」后再导出。',
    noData: '无数据可导出',
    tooMany: '单次最多导出 10 万条，请缩小筛选范围'
  },

  // 消息相关
  message: {
    queryFailed: '查询失败',
    exportSuccess: '导出成功',
    exportFailed: '导出失败'
  },

  // 分页相关
  pagination: {
    total: '共 {{total}} 条记录'
  }
};
